import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
// components
import PrintPO from "../../../components/utilities/print/default/po";
// middlewares
import AuthMiddleware from "../../../reducers/auth/middleware";
import PurchaseOrderMiddleware from "../../../middleware/modules/purchasing/purchase-order";
import PriceComparisonPDF from "../../../components/utilities/print/default/price-comparison-selling";
import PriceComparisonReportMiddleware from "../../../middleware/modules/report/price-comparison";
import PriceComparisonPurchasingPDF from "../../../components/utilities/print/default/price-comparison-purchasing";

const mapStateToProps = ({ auth, priceComparisonReport }) => ({
  isAuthenticated: auth.isAuthenticated,
  isRegistered: auth.isRegistered,
  isError: auth.isError,
  errorMessage: auth.errorMessage,
  isProcessing: priceComparisonReport.isProcessingPurchasing,
  dataPrint: priceComparisonReport.printPurchasing,
  requestPrint:priceComparisonReport.requestPrint
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getPrintPurchasing: (data) => PriceComparisonReportMiddleware.getPrintPurchasing(data),
    },
    dispatch
  );
};

class PriceComparisonPurchasingPrint extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.any,
    requestPrint:PropTypes.bool
  };

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: [],
    requestPrint:false
  };

  UNSAFE_componentWillMount() {
    this.props.getPrintPurchasing(this.props.data);
  }

  render() {
    return <PriceComparisonPurchasingPDF {...this.props} />;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PriceComparisonPurchasingPrint);
